export default '4.74.2';